<div class="step-container">
    <form [formGroup]="Form">
        <div id="ssb-form-content" class="form-content">
            <div class="form-section mb-30">
                <div class="mb-10">
                    <label class="label-question">
                        Are you currently receiving Social Security benefits?
                    </label>
                </div>
                <machinify-enterprise-yes-no id="ssb-yes-no-hasreceived-ssb"
                    #HasReceivedSocialSecurityBenefits
                    formControlName="HasReceivedSocialSecurityBenefits" [Hidden]="false"
                    [HideIfDisabled]="false"
                    [InputId]="'ssb-yes-no-hasreceived-ssb'"
                    [InputName]="'HasReceivedSocialSecurityBenefits'">
                </machinify-enterprise-yes-no>
            </div>
            <div *ngIf="ShowDateOfApplication" class="inline-form-date">
                <enterprise-date-input id="ssb-input-doa"
                                    Label="Date of Application"
                                    formControlName="DateOfApplication"
                                    class="inline-form-input"
                                    [Appearance]="'outline'"
                                    [InputId]="'ssb-input-doa'"
                                    [InputName]="'DateOfApplication'">
                </enterprise-date-input>
            </div>
            <div *ngIf="ShowIsSupposedReceivingSocialSecurityBenefits" class="form-section mb-30">
                <div class="mb-10">
                    <label class="label-question">
                        Is your spouse currently receiving Social Security benefits?
                    </label>
                </div>
                <app-toggle-confirm-dialog  id="ssb-toggle-spouse-receiving-ssb"
                                        #SpouseReceivingSocialSecurityBenefits
                                        formControlName="IsSpouseReceivingSocialSecurityBenefits"
                                        class="question-answer-input"
                                        (Change)="HandleSpouseToggleEvent($event)"
                                        [ShowLabel]="false"
                                        [ShowConfirmDialogForNO]="false"
                                        [ShowConfirmDialogForU]="false"
                                        [SkipModal]="true"
                                        [ShowButtonU]="true"
                                        [InputId]="'ssb-toggle-spouse-receiving-ssb'"
                                        [InputName]="'IsSpouseReceivingSocialSecurityBenefits'">
                </app-toggle-confirm-dialog>
            </div>
            <div *ngIf="ShowSpouseDateOfApplication" class="inline-form-date">
                <enterprise-date-input
                                    id="ssb-toggle-spouse-receiving-ssb"
                                    Label="Date of Application"
                                    formControlName="SpouseDateOfApplication"
                                    class="inline-form-input" [Appearance]="'outline'"
                                    [InputId]="'ssb-input-spouse-dao'"
                                    [InputName]="'SpouseDateOfApplication'">
                </enterprise-date-input>
            </div>

        </div>
    </form>
</div>
